import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum CovidAcknowledgementStep {
  Acknowledgement = 'Acknowledgement',
  Reschedule = 'Reschedule',
}

export const covidAcknowledgementFlow: CheckinWorkflow<CovidAcknowledgementStep> = {
  id: FlowId.CovidAcknowledgement,
  entry: CovidAcknowledgementStep.Acknowledgement,
  steps: {
    [CovidAcknowledgementStep.Acknowledgement]: {
      id: CovidAcknowledgementStep.Acknowledgement,
      page: PageKey.COVID,
      next: (variables) =>
        variables.hasAcknowledgeCovidVerification
          ? { complete: true }
          : { nextStep: CovidAcknowledgementStep.Reschedule },
      exit: () => ({ bubble: 'exit' }),
    },
    [CovidAcknowledgementStep.Reschedule]: {
      id: CovidAcknowledgementStep.Reschedule,
      page: PageKey.COVID_RESCHEDULE,
      next: () => ({ bubble: 'exit' }),
      exit: () => ({ bubble: 'exit' }),
    },
  },
};
